import React, { useState } from 'react';
import LocationTabs from '../common/LocationTabs';
import TempBatchManager from './TempBatchManager'

const ReviewBatchManager = () => {
  const [location, setLocation] = useState('Madison 1');
  const [batch, setBatch] = useState('HPCDW');
  const [user, setUser] = useState("");

  const handleLocationChange = (newLocation) => {
    setLocation(newLocation);
  };
  
  const handleBatchChange = (newBatch) => {
    setBatch(newBatch);
  };
  const handleUserChange = (value) => {
    setUser(value);
  };
  return (
    <div>
      <div className="columns">
        <div className="column">
          <span className="title">Batch Manager</span>
        </div>
      </div>

      <LocationTabs
        selectedLocation={location}
        onLocationChange={handleLocationChange}
        onBatchChange={handleBatchChange}
        onUserChange={handleUserChange}
        isFromBatchManager={true}
      />
      <br />
      <TempBatchManager
        location={location}
        batch={batch}
      />
    </div>
  );
};

export default ReviewBatchManager;
